import React from 'react';
import { business, footerLinks, hours, safetyLinks } from '../data/site';
export function Footer() {
  return <footer className="gutter w-full bg-white pb-28 pt-16 lg:pb-12" data-id="element-146" data-mp="3ggaqfufcyb4x">
      <div className="grid gap-12 md:grid-cols-2 xl:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-147" data-mp="32o4d0g3lai96">
        <div data-id="element-148" data-mp="36pfs3rou7l34">
          <img src={business.logo} alt="Soundside Marine Services logo" loading="lazy" className="h-24 w-auto" data-id="element-149" data-mp="36p6bgupomqa3" />
          <p className="mt-5 font-semibold text-navy" data-id="element-150" data-mp="3uesb1j9yv7im">Authorized Yamaha &amp; Honda Outboard Dealer</p>
          <address className="mt-4 space-y-1 not-italic text-ink-muted" data-id="element-151" data-mp="38zbozae1d6l">
            <p data-id="element-152" data-mp="3lem1u9lawtp9">
              {business.street}, {business.city}, {business.state} {business.zip}
            </p>
            <p data-id="element-153" data-mp="3qcx9qes1cu4u">
              <a href={business.tel} className="font-semibold text-navy hover:text-water-600" data-id="element-154" data-mp="3qcdsz1e4gbse">
                {business.phone}
              </a>
            </p>
            <p data-id="element-155" data-mp="2eya1c1v0azqi">
              <a href={`mailto:${business.email}`} className="hover:text-water-600" data-id="element-156" data-mp="2eyt76k7dtxo6">
                {business.email}
              </a>
            </p>
          </address>
        </div>
        <div data-id="element-157" data-mp="3gah1hulpfl6d">
          <h2 className="text-sm font-bold text-navy" data-id="element-158" data-mp="3gaz3l7v1stm7">Hours</h2>
          <dl className="mt-4 space-y-2 text-[15px]" data-id="element-159" data-mp="3gcjvsqtw40gw">
            {hours.map(h => <div key={h.day} data-id="element-160" data-mp="3v916dfu99b2e">
                <dt className="font-semibold text-ink" data-id="element-161" data-mp="3q8wrtvcwqqet">{h.day}</dt>
                <dd className="text-ink-muted" data-id="element-162" data-mp="3qapzndz9bgoe">{h.time}</dd>
              </div>)}
          </dl>
        </div>
        <nav aria-label="Footer" data-id="element-163" data-mp="33xdnwzdzwrz">
          <h2 className="text-sm font-bold text-navy" data-id="element-164" data-mp="34p8v6p2nshq">Quick Links</h2>
          <ul className="mt-4 space-y-2 text-[15px]" data-id="element-165" data-mp="hstrybs1e611">
            {footerLinks.map(l => <li key={l.href} data-id="element-166" data-mp="ctqmwrc23zt2">
                <a href={l.href} className="text-ink-muted hover:text-navy" data-id="element-167" data-mp="cth01cmb68rl">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <div data-id="element-168" data-mp="msg7wsz920dj">
          <h2 className="text-sm font-bold text-navy" data-id="element-169" data-mp="mspq3ue1z38o">Boating Safety</h2>
          <ul className="mt-4 space-y-2 text-[15px]" data-id="element-170" data-mp="tvcydolszzdk">
            {safetyLinks.map(l => <li key={l.href} data-id="element-171" data-mp="yu7iquzf5vzs">
                <a href={l.href} target="_blank" rel="noopener noreferrer" className="text-ink-muted hover:text-navy" data-id="element-172" data-mp="yv94puhz42wa">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
      <p className="mt-14 border-t border-navy/10 pt-6 text-sm text-ink-soft" data-id="element-173" data-mp="18m3qyyv7z2hq">© 2026 Soundside Marine Services. All rights reserved.</p>
    </footer>;
}